module.exports = __webpack_public_path__ + "static/sw-badge-front-14455fdec5ffd26ca6abdb3f386fc4e3.png";